/* eslint-disable import/no-anonymous-default-export */
import cars from './cars';
import website from './website';

export default {
  cars,
  website,
};



// WEBPACK FOOTER //
// ./src/utils/api/index.js